import { render } from "./App.vue?vue&type=template&id=10cba6a6&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=10cba6a6&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=10cba6a6&lang=css"
import "./App.vue?vue&type=style&index=2&id=10cba6a6&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cba6a6"]])

export default __exports__